<section [formGroup]="stepForm">
  <mbs-form-group *ngIf="isVirtual || (isRestoreHyperV && !importVirtualMachine)"
                  [attr.data-test-element]="elementsSelector.name.notVirtualOrHyperVBlock">
    <mbs-destination-folder [disabled]="stepForm.get('destinationFolder').disabled"
                            [forceValidate]="stepForm.get('destinationFolder').touched"
                            [params]="destinationFolderParams"
                            [(ngModel)]="destinationFolderData"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="destinationFolderDataChangeHandler()"></mbs-destination-folder>
  </mbs-form-group>

  <div *ngIf="notVirtualAndHyperV && importVirtualMachine"
       [attr.data-test-element]="elementsSelector.name.notVirtualHyperVAndImportBlock">
    <h5 class="mb-2">{{ 'wizards:destFolderLabel' | i18next : { format: 'title' } }}</h5>
    <mbs-form-group>
      <mbs-radio formControlName="toOriginalLocation"
                 name="toOriginalLocation"
                 [descriptionOutside]="false"
                 [label]="'wizards:dest_specific_location_label' | i18next"
                 [value]="false"
                 (change)="powerOnVMChangeHandler($event)"
                 [id]="'to-original-location-radio-1'">
        <ng-template radioDescription>
          <mbs-destination-folder [disabled]="stepForm.get('destinationFolder').disabled"
                                  [forceValidate]="stepForm.get('destinationFolder').touched"
                                  [hideLabel]="true"
                                  [params]="destinationFolderParams"
                                  [(ngModel)]="destinationFolderData"
                                  [ngModelOptions]="{ standalone: true }"
                                  (ngModelChange)="destinationFolderDataChangeHandler()"></mbs-destination-folder>
        </ng-template>
      </mbs-radio>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-radio formControlName="toOriginalLocation"
                 name="toOriginalLocation"
                 [label]="'wizards:destOriginalLocationLabel' | i18next"
                 [value]="true"
                 (change)="powerOnVMChangeHandler($event)"
                 [id]="'to-original-location-radio-2'"></mbs-radio>
    </mbs-form-group>
  </div>

  <mbs-form-group *ngIf="notVirtualAndHyperV && !importVirtualMachine"
                  [attr.data-test-element]="elementsSelector.name.notVirtualAndHyperVOrShowBlock">
    <mbs-switcher formControlName="overwriteExistingVM"
                  [label]="'wizards:destOverwriteVMLabel' | i18next"
                  [id]="'overwrite-existing-vm-switcher'"></mbs-switcher>
  </mbs-form-group>

  <mbs-form-group *ngIf="isRestoreVMWareToVSphere">
    <h5 class="mb-2">{{ 'wizards:datastoreTitle' | i18next : { format: 'title' } }}</h5>
    <mbs-select formControlName="dataStore"
                [appendTo]="'.modal-content'"
                [clearable]="false"
                [hideSelected]="false"
                [showRequiredMark]="false"
                [items]="dataStoreList"
                [id]="'restoreOptionsDataStore'"
                [loading]="dataStoreLoading"
                [label]="'wizards:restoreOptionsDatastoreLabel' | i18next"
                [searchable]="false"></mbs-select>
  </mbs-form-group>

  <mbs-form-group *ngIf="(notVirtualAndHyperV && importVirtualMachine) || isRestoreVMWareToVSphere">
    <h5 class="mb-2">{{ 'wizards:additionalSettingsTitle' | i18next : { format: 'title' } }}</h5>
    <mbs-switcher formControlName="powerOnVM"
                  [label]="(isRestoreHyperV ? 'wizards:powerOnHVVMLabel' : 'wizards:powerOnVMLabel') | i18next"
                  [id]="'power-on-vm-checkbox'"></mbs-switcher>
  </mbs-form-group>

  <mbs-destination-table *ngIf="needTableShow"
                         [(ngModel)]="overwriteAndSpecific"
                         [ngModelOptions]="{ standalone: true }"
                         (ngModelChange)="overwriteAndSpecificChangeHandler($event)"
                         [attr.data-test-element]="elementsSelector.name.tableGrid"
                         [dataForItems]="itemsData"
                         [forceValidate]="forceValidate"
                         [isVirtual]="isVirtual"
                         [loadingTableData]="loadingTableData"
                         [planType]="planType"
                         [showState]="needTableShow"></mbs-destination-table>
</section>
